import React, { useEffect, useState } from 'react';

import { ChevronDown, ChevronUp } from 'lucide-react';

interface TOCItem {
  id: string;
  text: string;
  level: number;
}

interface TableOfContentsProps {
  title: string;
  onLinkClick: (id: string) => void;
}

const TableOfContents: React.FC<TableOfContentsProps> = ({ title, onLinkClick }) => {
  const [tocItems, setTocItems] = useState<TOCItem[]>([]);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const headings = Array.from(document.querySelectorAll('h2')).filter(
      heading => heading.textContent !== title && heading.id
    );
    const items = headings.map((heading) => ({
      id: heading.id,
      text: heading.textContent || '',
      level: parseInt(heading.tagName.charAt(1)),
    }));
    setTocItems(items);
  }, [title]);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleLinkClick = (id: string) => {
    onLinkClick(id);
  };

  if (tocItems.length === 0) {
    return null;
  }

  return (
    <nav className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">{title}</h2>
        <button onClick={toggleVisibility} className="text-blue-600 dark:text-blue-400 hover:underline">
          {isVisible ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      </div>
      {isVisible && (
        <ul className="space-y-2">
          {tocItems.map((item) => (
            <li key={item.id} className={`ml-${(item.level - 2) * 4}`}>
              <a
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(item.id);
                }}
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default TableOfContents;
